import { useEffect, useState } from 'react';
import { Select, Space } from 'antd';
import { getAsociaciones, asignarAsociacion } from 'services/Asociaciones';
import { routesNames } from 'utils/Constants';
import { useAuth } from "hooks/useAuth";

const Asociaciones = ({ defaultValue, cuenta }) => {
    const [asociaciones, setAsociaciones] = useState([])
    const [asociacionSeleccionada, setAsociacionSeleccionada] = useState(null)
    const { userData } = useAuth()

    useEffect(() => {
        obtenerAsociaciones()
        console.log(cuenta)
    }, [])

    async function obtenerAsociaciones() {
        const data = await getAsociaciones()
        const opciones = data.map(item => ({
            value: item.id,
            label: item.nombre
        }))
        setAsociaciones(opciones)
    }

    const handleChange = value => {
        setAsociacionSeleccionada(value)
    }

    const asignar = async () => {

        const dataAsoc = {
            cuenta_id: cuenta,
            asociacion_id: asociacionSeleccionada == undefined || asociacionSeleccionada == "" ? null : asociacionSeleccionada
        }

        try {
            await asignarAsociacion(dataAsoc).then((response) => {
                if (response) {
                    window.location.reload();
                } else {
                    console.error(response)
                }
            })
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <div className="flex flex-col gap-4">
            <Space wrap>
                <Select
                    name="asociacion"
                    placeholder="Asociaciones"
                    allowClear
                    showSearch
                    size="large"
                    style={{ width: 200 }}
                    onChange={handleChange}
                    options={asociaciones}
                    defaultValue={defaultValue}
                />

                <button onClick={asignar} className='bg-main text-sm px-6 font-bold py-2 rounded-lg hover:opacity-80' type='button'>
                    {asociacionSeleccionada == undefined || asociacionSeleccionada == "" ? "Guardar" : "Asignar"}
                </button>
            </Space>

            <a
                href={routesNames.ASOCIACIONES}
                target="_blank"
                rel="noreferrer"
                className="w-fit rounded-lg bg-lightPrimary px-3 py-2 text-sm font-semibold text-navy-700 transition duration-200 hover:bg-gray-100 dark:bg-navy-700 dark:text-white dark:hover:bg-white/20"
            >
                Administrar asociaciones
            </a>
        </div>
    )
}

export default Asociaciones;
